export enum TimeInputMode {
    Circular,
    CircularForwarding,
    Limit,
}
